import { nullable, number, object, string } from "superstruct";

import GiftRegistrantSchema from "./GiftRegistrantSchema";

const GiftRegistryWithRegistrantSchema = object({
    typeId: number(),
    title: string(),
    date: string(),
    id: number(),
    registrantId: number(),
    ordersCount: number(),
    createdAt: string(),
    updatedAt: nullable(string()),
    registrant: GiftRegistrantSchema,
});

export default GiftRegistryWithRegistrantSchema;
